"use strict";

exports.__esModule = true;
exports.UsersSelector = UsersSelector;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _UserListContext = require("../UserListContext");
var _Core = require("../../Core");
var _UserSelector = require("../UserSelector");
var _excluded = ["onChange", "value"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function UsersSelector(props) {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var _useContext2 = (0, _react.useContext)(_UserListContext.UserListContext),
    userList = _useContext2.userList;
  var onChange = props.onChange,
    value = props.value,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var enabledUsers = userList.filter(function (user) {
    return user.isEnabled;
  });
  return /*#__PURE__*/_react["default"].createElement(_Core.DropdownCheckboxList, _extends({
    dataTestId: "UsersSelector.selector",
    selected: value == null ? enabledUsers : value,
    items: enabledUsers,
    itemPredicate: _UserSelector.itemPredicate,
    renderItemText: _UserSelector.renderItemText,
    getKey: function getKey(item) {
      return item.id;
    },
    onSelect: function onSelect(e) {
      if (!e || e.length === 0) {
        onChange([]);
        return;
      }
      if (e.length === enabledUsers.length) {
        onChange(null);
        return;
      }
      onChange(e.map(function (user) {
        return user.id;
      }));
    },
    icon: _icons.IconNames.BOX,
    placeholder: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UsersSelector.placeholder",
      defaultMessage: "Select users"
    }),
    searchPlaceHolder: translate("UsersSelector.search.placeholder", "Search for user")
  }, extra));
}